import _get from 'lodash/get';

// import FrontConfig from 'public/frontConfig.js';

interface FrontConfigInterface {
	API_ENTRYPOINT: string;
	APP_ENV: string;
	SENTRY_DSN: string;
	[key: string]: unknown;
}

declare global {
	interface Window {
		FRONT_CONFIG?: FrontConfigInterface;
	}
}

const DEFAULT_CONFIG: FrontConfigInterface = {
	API_ENTRYPOINT: '',
	APP_ENV: 'dev',
	SENTRY_DSN: '',
};

// const frontConfig: FrontConfig = window.FRONT_CONFIG || FrontConfig || {};
const frontConfig: FrontConfigInterface = window.FRONT_CONFIG || DEFAULT_CONFIG;

const get = <T = unknown>(key: string): T => {
	const value = _get(frontConfig, key);

	if (typeof value === 'undefined') {
		if (import.meta.env.DEV) {
			console.warn('No env variable defined for key:', key);
		}
	}

	return value as T;
};

export default {
	get,
};
